{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://ceo-os.local/schemas/v1/ceo-review-export.schema.json",
  "title": "CEOReviewExport v1",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schema_name",
    "schema_version",
    "contract_id",
    "produced_at",
    "producer",
    "payload_hash",
    "payload"
  ],
  "properties": {
    "schema_name": { "const": "ceo-review-export" },
    "schema_version": { "const": "1.0.0" },
    "contract_id": { "type": "string", "format": "uuid" },
    "produced_at": { "type": "string", "format": "date-time" },
    "producer": { "const": "ceo-os" },
    "payload_hash": { "type": "string", "pattern": "^[a-f0-9]{64}$" },
    "payload": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "review_id",
        "date",
        "uncomfortable_truth",
        "focus_deviation",
        "repetition_failure",
        "trust_deviation",
        "decision_quality_issue",
        "delegation_issue",
        "risk_issue",
        "energy_issue",
        "field_adaptation_issue",
        "tomorrow_behavior_correction",
        "confidence",
        "evidence"
      ],
      "properties": {
        "review_id": { "type": "string", "format": "uuid" },
        "date": { "type": "string", "format": "date" },
        "uncomfortable_truth": { "type": ["string", "null"], "minLength": 1 },
        "focus_deviation": { "type": ["string", "null"], "minLength": 1 },
        "repetition_failure": { "type": ["string", "null"], "minLength": 1 },
        "trust_deviation": { "type": ["string", "null"], "minLength": 1 },
        "decision_quality_issue": { "type": ["string", "null"], "minLength": 1 },
        "delegation_issue": { "type": ["string", "null"], "minLength": 1 },
        "risk_issue": { "type": ["string", "null"], "minLength": 1 },
        "energy_issue": { "type": ["string", "null"], "minLength": 1 },
        "field_adaptation_issue": { "type": ["string", "null"], "minLength": 1 },
        "tomorrow_behavior_correction": { "type": "string", "minLength": 1 },
        "confidence": { "type": "number", "minimum": 0, "maximum": 1 },
        "evidence": {
          "type": "array",
          "items": { "$ref": "#/$defs/evidence" },
          "uniqueItems": true
        }
      }
    }
  },
  "$defs": {
    "evidence": {
      "type": "object",
      "additionalProperties": false,
      "required": ["evidence_id", "kind", "statement", "export_approved"],
      "properties": {
        "evidence_id": { "type": "string", "format": "uuid" },
        "kind": {
          "enum": [
            "user_observation",
            "board_context",
            "promise_record",
            "decision_record",
            "behavior_history"
          ]
        },
        "statement": { "type": "string", "minLength": 1 },
        "observed_at": { "type": "string", "format": "date-time" },
        "source_record_id": { "type": "string", "format": "uuid" },
        "export_approved": { "const": true }
      }
    }
  },
  "examples": [
    {
      "schema_name": "ceo-review-export",
      "schema_version": "1.0.0",
      "contract_id": "6d228e99-4f15-4dc1-9b9d-8d1d5437438d",
      "produced_at": "2026-07-26T21:30:00+08:00",
      "producer": "ceo-os",
      "payload_hash": "8638069a959aa5707dd3bc8fce54a6f0799cc0e4004b51c58366ef58bf076e7d",
      "payload": {
        "review_id": "f6e77537-796c-4c23-b749-ec0bc2407e30",
        "date": "2026-07-26",
        "uncomfortable_truth": "本周尚未取得任何付费诊断。",
        "focus_deviation": null,
        "repetition_failure": null,
        "trust_deviation": null,
        "decision_quality_issue": null,
        "delegation_issue": null,
        "risk_issue": null,
        "energy_issue": null,
        "field_adaptation_issue": null,
        "tomorrow_behavior_correction": "明日 11:00 前完成 3 次客户触达。",
        "confidence": 0.86,
        "evidence": []
      }
    }
  ]
}
